export const onuTableStyles = () => `
  /* O cabeçalho é renderizado numa tabela clonada, separada da tabela do
     corpo. O texto só bate com a célula se o recuo horizontal for idêntico
     nos dois: no th o recuo vem somado (padding do th + padding do .relative
     que o Handsontable insere dentro dele), então zeramos o interno e
     deixamos um único valor, igual ao do td. */
  .onu-table-wrapper .handsontable thead th,
  .onu-table-wrapper .handsontable tbody td {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 12px;
  }

  .onu-table-wrapper .handsontable thead th .relative {
    padding-left: 0;
    padding-right: 0;
  }

  /* Coluna de seleção: cabeçalho centralizado igual ao corpo. */
  .onu-table-wrapper .handsontable thead th.onu-header-center,
  .onu-table-wrapper .handsontable thead th.onu-header-center .relative {
    text-align: center !important;
    padding-left: 0;
    padding-right: 0;
  }

  /* O checkbox das linhas nasce com margin-right de 5px no CSS do
     Handsontable, o do cabeçalho não: centralizados, um cai meio recuo à
     esquerda do outro. Sem margem os dois ficam no mesmo eixo. */
  .onu-table-wrapper .handsontable .htCheckboxRendererInput,
  .onu-table-wrapper .handsontable .ht-select-all {
    margin: 0;
  }

  /* Seleção parcial: o customStyles só desenha o estado marcado (appearance
     none apaga o traço nativo do indeterminate), então o traço vem daqui. */
  .onu-table-wrapper .handsontable .ht-select-all:indeterminate {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }

  .onu-table-wrapper .handsontable .ht-select-all:indeterminate::after {
    content: '';
    position: absolute;
    left: 2px;
    top: 5px;
    width: 8px;
    height: 2px;
    background-color: #FFFFFF;
  }

  .onu-table-wrapper .handsontable td {
    cursor: pointer;
  }
`;
